import * as React from 'react'

const SvgThumbsUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 5.875H11.5V2.75A2.275 2.275 0 009 .25h-.981a.944.944 0 00-.894.731v.075L6.5 5.02 4.287 8.375H.25v8.75h11.875c4.65 0 5.625-2.719 5.625-5v-3.75a2.275 2.275 0 00-2.5-2.5zM4 15.875H1.5v-6.25H4v6.25zm12.5-3.75c0 2.556-1.387 3.75-4.375 3.75H5.25V9.187l2.5-3.706.456-3.356.088-.625H9c.9 0 1.25.35 1.25 1.25v4.375h5c.9 0 1.25.35 1.25 1.25v3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgThumbsUp
